const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const OtpPasswordQuery: any = {
    GetCountryRateLimit: Backofficebff + '/v1/smsratelimit/country-rate-limit',
    GetRequestLogs: Backofficebff + '/v1/smsratelimit/request-logs',
    GetRateLimitHistory: Backofficebff + '/v1/smsratelimit/history',
};
